export const ACCOUNT_STATUS = {
    INACTIVE: 0,
    ACTIVE: 1,
    PAUSED: 2,
    SHUTDOWN: 3,
    DISCONNECTED: 4,
    BLOCKED: 5
};

export const CONNECTOR_KLICKLY_STATUS = {
    DISCONNECTED: 1,
    CONNECTED: 2,
    PENDING: 3
};

export const ACCOUNT_RESOURCE_STATUS = {
    PENDING: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    FAILED: 3
};

// names of the `syncProgress` (kl_account_resource) rows returned by the API
export const ACCOUNT_RESOURCE_NAME = {
    PRODUCTS: 'products',
    CUSTOM_COLLECTIONS: 'customCollections',
    SMART_COLLECTIONS: 'smartCollections',
    PRODUCT_STATS: 'productStats'
};

export const NOTIFICATION_ACTIONS = {
    ACCOUNT: 1,
    MARKETING: 2,
    CAMPAIGN: 3
};

export const ACCOUNT_USER_STATUS = {
    BLOCKED: 0,
    ACTIVE: 1,
    INVITED: 2,
    PENDING: 3,
    DECLINED: 4,
    TRANSFER_OWNERSHIP: 5
};

export const ACCOUNT_USER_ROLE = {
    OWNER: 1,
    ADMIN: 2,
    MEMBER: 3,
    DEVELOPER: 4
};

export const TRACK_EVENT = {
    VIEWS: 1,
    CLICKS: 2,
    ADD_TO_CARTS: 3,
    PURCHASES: 4
};

export const DOMAIN_STATUS = {
    VERIFIED: 1
};

export const DOMAIN_CLASS = {
    MAIN_ECOMMERCE: 1,
    REST_ECOMMERCE: 2,
    MAIN_CUSTOM: 3,
    REST_CUSTOM: 4
};
